var dayselect =
webpackJsonpdayselect([4],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(56);
	module.exports = __webpack_require__(162);


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.renderFunshineEditor = renderFunshineEditor;
	
	var _react = __webpack_require__(10);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ChildrenEditor = __webpack_require__(73);
	
	var _immutabilityHelper = __webpack_require__(44);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _AuthorizedContacts = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputRow = function InputRow(_ref) {
	    var label = _ref.label,
	        children = _ref.children;
	    return _react2.default.createElement(
	        "div",
	        { className: "input-group" },
	        _react2.default.createElement(
	            "label",
	            null,
	            label
	        ),
	        children
	    );
	};
	
	var FunshineRow = function (_React$Component) {
	    _inherits(FunshineRow, _React$Component);
	
	    function FunshineRow(props) {
	        _classCallCheck(this, FunshineRow);
	
	        var _this = _possibleConstructorReturn(this, (FunshineRow.__proto__ || Object.getPrototypeOf(FunshineRow)).call(this, props));
	
	        _this.state = {
	            afterschool: null,
	            requireVoucher: false,
	            voucherKey: "",
	            voucher: "",
	            breakfast: false
	        };
	        return _this;
	    }
	
	    _createClass(FunshineRow, [{
	        key: "upd",
	        value: function upd(state) {
	            var _this2 = this;
	
	            this.setState(state, function () {
	                _this2.props.onChange(_this2.props.value, _this2.state.breakfast || _this2.state.afterschool != null);
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    this.props.label
	                ),
	                _react2.default.createElement(
	                    "td",
	                    { className: "checkbox-options" },
	                    _react2.default.createElement("input", { type: "checkbox", name: "select_breakfast[]", value: this.props.value, checked: this.state.breakfast, onChange: function onChange() {
	                            return _this3.upd({ breakfast: !_this3.state.breakfast });
	                        }, id: "js-" + this.props.value + "-breakfast" }),
	                    _react2.default.createElement("label", { htmlFor: "js-" + this.props.value + "-breakfast" })
	                ),
	                _react2.default.createElement(
	                    "td",
	                    { className: "checkbox-options" },
	                    _react2.default.createElement("input", { type: "checkbox", name: "select_half[]", value: this.props.value, checked: this.state.afterschool == "half", onChange: function onChange() {
	                            return _this3.upd({ afterschool: _this3.state.afterschool != "half" ? "half" : null });
	                        }, id: "js-" + this.props.value + "-half" }),
	                    _react2.default.createElement("label", { htmlFor: "js-" + this.props.value + "-half" })
	                ),
	                _react2.default.createElement(
	                    "td",
	                    { className: "checkbox-options" },
	                    _react2.default.createElement("input", { type: "checkbox", name: "select_full[]", value: this.props.value, checked: this.state.afterschool == "full", onChange: function onChange() {
	                            return _this3.upd({ afterschool: _this3.state.afterschool != "full" ? "full" : null });
	                        }, id: "js-" + this.props.value + "-full" }),
	                    _react2.default.createElement("label", { htmlFor: "js-" + this.props.value + "-full" })
	                )
	            );
	        }
	    }]);
	
	    return FunshineRow;
	}(_react2.default.Component);
	
	var FunshineChildEditor = function (_React$Component2) {
	    _inherits(FunshineChildEditor, _React$Component2);
	
	    function FunshineChildEditor(props) {
	        _classCallCheck(this, FunshineChildEditor);
	
	        var _this4 = _possibleConstructorReturn(this, (FunshineChildEditor.__proto__ || Object.getPrototypeOf(FunshineChildEditor)).call(this, props));
	
	        _this4.state = {
	            kids: props.kids,
	            termsAgreed: false,
	            activeDays: [],
	            paymentMethod: null
	        };
	        _this4.onDayRowChange = _this4.onDayRowChange.bind(_this4);
	        return _this4;
	    }
	
	    _createClass(FunshineChildEditor, [{
	        key: "upd",
	        value: function upd(spec) {
	            this.setState((0, _immutabilityHelper2.default)(this.state, spec));
	        }
	    }, {
	        key: "onDayRowChange",
	        value: function onDayRowChange(day, active) {
	            console.log("onDayRowChange", day, active);
	            if (active && this.state.activeDays.indexOf(day) === -1) {
	                this.setState({ activeDays: [].concat(_toConsumableArray(this.state.activeDays), [day]) });
	            } else if (!active && this.state.activeDays.indexOf(day) !== -1) {
	
	                this.setState({ activeDays: [].concat(_toConsumableArray(this.state.activeDays)).splice(this.state.activeDays.indexOf(day), 1) });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this5 = this;
	
	            var canRemove = this.state.kids.length > 1;
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "js-ballpit" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        this.state.kids.map(function (kid, idx) {
	                            return _react2.default.createElement(_ChildrenEditor.ChildrenEntry, {
	                                key: idx,
	                                idx: idx,
	                                value: kid,
	                                onChange: function onChange(kid) {
	                                    return _this5.upd({ kids: _defineProperty({}, idx, { $set: kid }) });
	                                },
	                                onRemove: canRemove ? function () {
	                                    return _this5.upd({ kids: { $splice: [[idx, 1]] } });
	                                } : null
	                            });
	                        }),
	                        _react2.default.createElement(
	                            "button",
	                            { type: "button", id: "js-add-kid", onClick: function onClick() {
	                                    return _this5.upd({ kids: { $push: [{ dob: new Date().getFullYear() - 3 + "-01-01" }] } });
	                                } },
	                            "Add Child"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Contact Details"
	                        ),
	                        _react2.default.createElement(
	                            "fieldset",
	                            null,
	                            _react2.default.createElement(
	                                InputRow,
	                                { label: "Parent Name" },
	                                _react2.default.createElement("input", { type: "text", name: "parent-name", required: true })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "grouped-inputs-1" },
	                                _react2.default.createElement(
	                                    InputRow,
	                                    { label: "Primary Contact No. *" },
	                                    _react2.default.createElement("input", { type: "tel", pattern: "\\d{11}", title: "Enter a valid phone number (11 digits, no spaces)", name: "parent-tel", required: true })
	                                ),
	                                _react2.default.createElement(
	                                    InputRow,
	                                    { label: "Second Contact No. *" },
	                                    _react2.default.createElement("input", { type: "tel", pattern: "\\d{11}", title: "Enter a valid phone number (11 digits, no spaces)", name: "parent-tel-2", required: true })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                InputRow,
	                                { label: "Email" },
	                                _react2.default.createElement("input", { type: "text", name: "parent-email", required: true })
	                            )
	                        ),
	                        _react2.default.createElement(_AuthorizedContacts.AuthorizedContacts, null)
	                    )
	                ),
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Choose your sessions"
	                ),
	                _react2.default.createElement(
	                    "fieldset",
	                    null,
	                    _react2.default.createElement(
	                        InputRow,
	                        { label: "Start date *" },
	                        _react2.default.createElement("input", { className: "datepicker", type: "text", name: "start_date", required: true })
	                    )
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { id: "wrap-around-selector" },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement("th", null),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Breakfast Club",
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    this.props.times[0]
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    "\xA3",
	                                    this.props.pricing[0],
	                                    " per day"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "After School Club",
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    this.props.times[1]
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    "Half: \xA3",
	                                    this.props.pricing[1],
	                                    " per day"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "After School Club",
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    this.props.times[2]
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    "Full: \xA3",
	                                    this.props.pricing[2],
	                                    " per day"
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(FunshineRow, { label: "Mon", value: "monday", onChange: this.onDayRowChange }),
	                        _react2.default.createElement(FunshineRow, { label: "Tue", value: "tuesday", onChange: this.onDayRowChange }),
	                        _react2.default.createElement(FunshineRow, { label: "Wed", value: "wednesday", onChange: this.onDayRowChange }),
	                        _react2.default.createElement(FunshineRow, { label: "Thu", value: "thursday", onChange: this.onDayRowChange }),
	                        _react2.default.createElement(FunshineRow, { label: "Fri", value: "friday", onChange: this.onDayRowChange })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "radio-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "radio-payment-options" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "grid-container smaller" },
	                            _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Payment method"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                "Please select your preferred method of payment for your monthly Invoice fees"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "confirm" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "i-group" },
	                                    _react2.default.createElement("input", { type: "radio", id: "pay-by-bacs", name: "pay-by", value: "bacs", onChange: function onChange() {
	                                            return _this5.setState({ paymentMethod: "bacs", requireVoucher: false });
	                                        } }),
	                                    _react2.default.createElement(
	                                        "label",
	                                        { htmlFor: "pay-by-bacs" },
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "Pay by BACs ",
	                                            _react2.default.createElement(
	                                                "i",
	                                                null,
	                                                "BACs information will be provided on your Invoice"
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "confirm" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "i-group" },
	                                    _react2.default.createElement("input", { type: "radio", id: "pay-by-online", name: "pay-by", value: "online", onChange: function onChange() {
	                                            return _this5.setState({ paymentMethod: "online", requireVoucher: false });
	                                        } }),
	                                    _react2.default.createElement(
	                                        "label",
	                                        { htmlFor: "pay-by-online" },
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "Pay Online ",
	                                            _react2.default.createElement(
	                                                "i",
	                                                null,
	                                                "Debit / Credit / PayPal"
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "confirm" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "i-group" },
	                                    _react2.default.createElement("input", { type: "radio", id: "pay-by-voucher", name: "pay-by", value: "voucher", onChange: function onChange() {
	                                            return _this5.setState({ paymentMethod: "voucher", requireVoucher: true });
	                                        } }),
	                                    _react2.default.createElement(
	                                        "label",
	                                        { htmlFor: "pay-by-voucher" },
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "Pay using childcare vouchers ",
	                                            _react2.default.createElement(
	                                                "i",
	                                                null,
	                                                "Please confirm which Childcare voucher you would like to use:"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { value: this.state.voucherKey, onChange: function onChange(ev) {
	                                                return _this5.setState({ voucherKey: ev.target.value, voucher: _this5.props.voucher[ev.target.value] });
	                                            } },
	                                        Object.keys(this.props.voucher).map(function (e) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: e, value: e },
	                                                e
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "breakout-container checkbox-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "check-confirmations" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "grid-container smaller" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "confirm" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "i-group" },
	                                    _react2.default.createElement("input", { type: "checkbox", name: "terms[]", value: "yes", id: "chk-terms-1", checked: this.state.termsAgreed1, onChange: function onChange() {
	                                            return _this5.setState({ termsAgreed1: !_this5.state.termsAgreed1 });
	                                        } }),
	                                    _react2.default.createElement(
	                                        "label",
	                                        { htmlFor: "chk-terms-1" },
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "By completing and submitting this registration form, I am entering into an agreement with Funshine Club and I will give a minimum of one month\u2019s notice if I wish to cancel my place."
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "confirm" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "i-group" },
	                                    _react2.default.createElement("input", { type: "checkbox", name: "terms[]", value: "yes", id: "chk-terms-2", checked: this.state.termsAgreed2, onChange: function onChange() {
	                                            return _this5.setState({ termsAgreed2: !_this5.state.termsAgreed2 });
	                                        } }),
	                                    _react2.default.createElement(
	                                        "label",
	                                        { htmlFor: "chk-terms-2" },
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "I understand the club is open for 39 term-time weeks. During this period Bank holidays, Inset days, polling days and unexpected school closures are chargeable at a normal daily rate."
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "confirm" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "i-group" },
	                                    _react2.default.createElement("input", { type: "checkbox", name: "terms[]", value: "yes", id: "chk-terms-3", checked: this.state.termsAgreed3, onChange: function onChange() {
	                                            return _this5.setState({ termsAgreed3: !_this5.state.termsAgreed3 });
	                                        } }),
	                                    _react2.default.createElement(
	                                        "label",
	                                        { htmlFor: "chk-terms-3" },
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "I have read and will abide by the Clubs Terms & Conditions, Policies, and Procedures which are available ",
	                                            _react2.default.createElement(
	                                                "a",
	                                                { href: "/TandCs-.html", target: "_blank" },
	                                                "here"
	                                            ),
	                                            " for reference."
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "chosen-options" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "days" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "icon" },
	                            _react2.default.createElement("img", { src: "/Templates/steps2sport/images/dates.png", alt: "Active Superstars Ltd" })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "info" },
	                            this.state.activeDays.length,
	                            "\xA0day",
	                            this.state.activeDays.length != 1 ? "s" : ""
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "multply" },
	                        _react2.default.createElement("img", { src: "/Templates/steps2sport/images/multiply.png", alt: "Active Superstars Ltd" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "num-children" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "icon" },
	                            _react2.default.createElement("img", { src: "/Templates/steps2sport/images/child.png", alt: "Active Superstars Ltd" })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "info" },
	                            this.state.kids.length,
	                            "\xA0child",
	                            this.state.kids.length != 1 ? "ren" : ""
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "pre-button-text" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "A registration fee of \xA315.00 (non-refundable) will need to be paid to complete your registration."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "When you submit your registration form you will be asked to visit our payment page."
	                    )
	                ),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        type: "submit",
	                        disabled: !this.state.termsAgreed1 || !this.state.termsAgreed2 || !this.state.termsAgreed3 || !this.state.paymentMethod },
	                    "Sign up to funshine"
	                )
	            );
	        }
	    }]);
	
	    return FunshineChildEditor;
	}(_react2.default.Component);
	
	function renderFunshineEditor(element) {
	    var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var voucherData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var pricing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	    var times = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	
	    _reactDom2.default.render(_react2.default.createElement(FunshineChildEditor, { kids: children, voucher: voucherData, pricing: pricing, times: times }), element);
	}

/***/ })

});


// WEBPACK FOOTER //
// funshine-editor.5b2716.js